<template>
  <div>
    <div v-if="visible">
      <Row>
        <ul :style="{left: pos.x + 'px', top: pos.y + 'px'}" class="contextMenu">
          <li style="margin-bottom: 3px;" v-for="(item, key) of menuList" @click="handleTagsOption(item)" :key="key">{{item.title}}</li>
          <li id="contextMenu_copyButton" @click="handleCopy">复制</li>
        </ul>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contextmenu',
  props:
    {
      menuList: {
        type: Array,
        required: true
      }
    },
  data () {
    return {
      visible:false,
      pos:{
        x:0,
        y:0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  },
  watch: {
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    handleCopy(){
      let input = document.getElementById("custom_copyInput")
      input.select()
      document.execCommand("Copy")
    },
    /**
     * 点击选项回调
     */
    handleTagsOption (item) {
      this.$emit('callback', item)
    },
    /**
     * 显示菜单
     */
    showMenu(event, el, offsetX, offsetY){
      if(!offsetX){
        offsetX = 0
      }
      if(!offsetY){
        offsetY = 0
      }
      const offsetLeft = el.getBoundingClientRect().left
      const offsetTop = el.getBoundingClientRect().top
      this.pos.x = event.clientX - offsetLeft + offsetX
      this.pos.y = event.clientY - offsetTop - 25 + offsetY
      this.visible = true
    },
    /**
     * 关闭菜单
     */
    closeMenu(){
      this.visible = false
    }
  },
  computed: {

  }
}
</script>

<style scoped>
  @import 'context-menu.less';
</style>
